// is this really better than normal case? Have to-remap in components for TS
export enum TestTypesMutations {
  RESET = "RESET",
  SET_TYPE = "SET_TYPE",
  SET_TYPES = "SET_TYPES",
  ADD = "ADD",
}
